import classNames from "classnames";
import { Immutable } from "immer";
import React from "react";

import { TsicommonCmsPromoPeriodOrNull } from "@reactivated";

import { EditorContent } from "@thelabnyc/thelabui/src/components/EditorContent";

import { IImageURL, WebPageURL } from "../../models/nominals";
import { Image } from "../Image";
import { Link } from "../Link";

import styles from "./index.module.scss";

export interface IMenuPromo {
    type: "nav_advert";
    value: {
        use_html_block: boolean;
        promo_period: TsicommonCmsPromoPeriodOrNull;
        external_link: WebPageURL;
        copy: string;
        image: {
            url: IImageURL;
            id: string;
            title: string;
        };
        page: {
            slug: string;
            url: WebPageURL;
        };
        html: string;
    };
}

type IProps = Immutable<{
    promoArrayEl: IMenuPromo;
}>;

export const PromoAd = (props: IProps): React.JSX.Element => {
    const { promoArrayEl } = props;
    const link = promoArrayEl.value.page
        ? promoArrayEl.value.page.url
        : promoArrayEl.value.external_link;

    const renderContent = (): React.JSX.Element => {
        if (promoArrayEl.value.use_html_block) {
            return (
                <EditorContent>
                    {(marker) => (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: promoArrayEl.value.html,
                            }}
                            {...marker}
                        />
                    )}
                </EditorContent>
            );
        }
        if (promoArrayEl.value.image) {
            return (
                <Image
                    alt={promoArrayEl.value.image.title}
                    src={promoArrayEl.value.image.url}
                />
            );
        }
        return (
            <div className={styles.container}>
                <div
                    className={styles.copy}
                    dangerouslySetInnerHTML={{
                        __html: promoArrayEl.value.copy,
                    }}
                />
            </div>
        );
    };

    const rootClassName = classNames({
        [styles.root]: true,
        [styles.rootSingleImage]: promoArrayEl.value.image,
        [styles.rootRawHtml]: promoArrayEl.value.use_html_block,
    });
    return link ? (
        <Link href={link} target="_top" className={rootClassName} tabIndex={0}>
            {renderContent()}
        </Link>
    ) : (
        <div className={rootClassName} tabIndex={0}>
            {renderContent()}
        </div>
    );
};
